import { Box, Avatar, Text, VStack, HStack, Switch } from "@chakra-ui/react";

const ProfileCard = ({ name, email, profileImage, isActive, onToggle }) => {
  return (
    <Box
      bg="white"
      p={4}
      borderRadius="md"
      boxShadow="sm"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      w="100%"
    >
      <HStack spacing={4}>
        <Avatar size="md" name={name} src={profileImage} />
        <VStack align="start" spacing={0}>
          <Text fontWeight="bold" fontSize="md">
            {name}
          </Text>
          <Text fontSize="sm" color="gray.500">
            {email}
          </Text>
        </VStack>
      </HStack>

      <HStack spacing={3} align="center">
        <Text
          fontSize="md"
          fontWeight="600"
          color={isActive ? "green.500" : "red.500"}
        >
          {isActive ? "Ενεργός" : "Ανενεργό"}
        </Text>
        <Switch
          colorScheme="green"
          isChecked={isActive}
          onChange={onToggle}
          size="md"
        />
      </HStack>
    </Box>
  );
};

export default ProfileCard;
